function unmaskValue(value: string, mask: string): string {
  if (!value || !mask) {
    return value;
  }
  return value.replace(/\W/g, '').substring(0, mask?.length);
}
function maskValue(value: string, mask: string): string {
  if (!value || !mask) {
    return value;
  }
  let clear = unmaskValue(value, mask);
  for (let i = 0; i < clear.length; i++) {
    if (mask.length <= i) {
      clear = clear.substring(0, i);
      break;
      // eslint-disable-next-line no-empty
    } else if (mask[i] === '_') {} else if (mask[i] === 'w') {
      const c = clear[i].toLowerCase();
      if (!(c >= '0' && c <= '9') && !(c >= 'a' && c <= 'z')) {
        clear = [clear.slice(0, i), clear.slice(i + 1)].join('');
        i--;
        continue;
      } else {
        clear = [clear.slice(0, i), c.toLowerCase(), clear.slice(i + 1)].join('');
      }
    } else if (mask[i] === 'a') {
      const c = clear[i].toLowerCase();
      if (!(c >= 'a' && c <= 'z')) {
        clear = [clear.slice(0, i), clear.slice(i + 1)].join('');
        i--;
        continue;
      } else {
        clear = [clear.slice(0, i), c.toLowerCase(), clear.slice(i + 1)].join('');
      }
    } else if (mask[i] === 'A') {
      const c = clear[i].toLowerCase();
      if (!(c >= 'a' && c <= 'z')) {
        clear = [clear.slice(0, i), clear.slice(i + 1)].join('');
        i--;
        continue;
      } else {
        clear = [clear.slice(0, i), c.toUpperCase(), clear.slice(i + 1)].join('');
      }
    } else if (mask[i] === '9') {
      const c = clear[i];
      if (!(c >= '0' && c <= '9')) {
        clear = [clear.slice(0, i), clear.slice(i + 1)].join('');
        i--;
        continue;
      }
    } else if (mask[i] === 'f') {
      const c = clear[i].toLowerCase();
      if (!(c >= '0' && c <= '9') && !(c >= 'a' && c <= 'f')) {
        clear = [clear.slice(0, i), clear.slice(i + 1)].join('');
        i--;
        continue;
      }
    } else {
      clear = [clear.slice(0, i), mask[i], clear.slice(i)].join('');
    }
  }
  return clear;
}
export { maskValue, unmaskValue };